<template>
	<div>
		<el-dialog title="添加" width="600px" class="icon-dialog" :visible.sync="show" @open="open" :before-close="closeForm"
			append-to-body>
			<el-form :size="size" ref="form" :model="form" :rules="rules"
				:label-width="$store.getters.device !== 'mobile' ? '16%' : '90px'">
				<el-row>
					<el-col :span="24">
						<el-form-item label="教练名称" prop="trainer_name">
							<el-input v-model="form.trainer_name" autoComplete="off" clearable
								placeholder="请输入用户姓名"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="登陆手机号" prop="trainer_phone">
							<el-input v-model="form.trainer_phone" autoComplete="off" clearable
								placeholder="请输入用户名"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="密码" prop="trainer_pass">
							<el-input show-password autoComplete="off" v-model="form.trainer_pass" clearable
								placeholder="请输入密码" />
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="上级代理">
							<el-select style="width: 160px;" size="small" v-model="form.pid" placeholder="请选择">
								<el-option v-for="type in type" :label="type.trainer_name" :value="type.trainer_user_id"
									:key="type.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="抽成比列" prop="commission">
							<el-input v-model="form.commission" autoComplete="off" clearable
								placeholder="最小0最大100"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="24">
						<el-form-item label="抖音平台" prop="is_dy">
							<el-radio-group v-model="form.is_dy">
								<el-radio :label="0">开启</el-radio>
								<el-radio :label="1">禁用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="快手平台" prop="is_ks">
							<el-radio-group v-model="form.is_ks">
								<el-radio :label="0">开启</el-radio>
								<el-radio :label="1">禁用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="微信平台" prop="is_wx">
							<el-radio-group v-model="form.is_wx">
								<el-radio :label="0">开启</el-radio>
								<el-radio :label="1">禁用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :size="size" :loading="loading" type="primary" @click="submit">
					<span v-if="!loading">确 定</span>
					<span v-else>提 交 中...</span>
				</el-button>
				<el-button :size="size" @click="closeForm">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { getTraineradd, getPid } from '../../api/userMG';
export default {
	name: 'Add',
	components: {
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'small'
		},
	},
	data() {
		return {
			form: {
				trainer_name: '',
				trainer_phone: '',
				trainer_pass: '',
				commission: '',
				pid: '',
				is_dy: 0,
				is_ks: 0,
				is_wx: 0
			},
			type: [],
			role_ids: [],
			loading: false,
			rules: {
			}
		}
	},
	watch: {
		show(val) {
			getPid().then(res => {
				console.log(res);
				this.type = res.trainer

			})
			// if(val){
			// 	getTrainer().then(res => {
			// 		if(res.status == 200){
			// 			this.role_ids = res.data.role_ids
			// 		}
			// 	})
			// }
		}
	},
	methods: {
		open() {
		},
		submit() {
			this.$refs['form'].validate(valid => {
				if (valid) {
					this.loading = true
					getTraineradd(this.form).then(res => {
						console.log(res);
						if (res.code == 200) {
							this.$message({ message: '操作成功', type: 'success' })
							this.$emit('refesh_list')
							this.closeForm()
						} else {
							this.$message({ message: res.msg, type: 'error' })
							this.loading = false
						}
					}).catch(() => {
						this.loading = false
					})
				}
			})
		},
		closeForm() {
			this.$emit('update:show', false)
			this.loading = false
			this.form  = {}
			if (this.$refs['form'] !== undefined) {
				this.$refs['form'].resetFields()
			}
		},
	}
}
</script>
<style scoped >
.ts{
	color: red;
	padding-left: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/coach/Add.vue